import { render, staticRenderFns } from "./simple-text-modal.vue?vue&type=template&id=d6faa4ea&scoped=true&"
import script from "./simple-text-modal.vue?vue&type=script&lang=js&"
export * from "./simple-text-modal.vue?vue&type=script&lang=js&"
import style0 from "./simple-text-modal.vue?vue&type=style&index=0&id=d6faa4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6faa4ea",
  null
  
)

export default component.exports